import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { SEO } from "@/components/SEO";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  const inputCls = "w-full bg-ivory border border-champagne/40 rounded-lg px-4 py-3 text-espresso focus:outline-none focus:ring-2 focus:ring-champagne focus:border-transparent";

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory px-6" data-testid="login-page">
      <SEO title="Admin Login" description="Admin sign in" />
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center font-serif text-3xl text-espresso">people, redefined.</Link>
        <p className="text-center text-xs uppercase tracking-[0.25em] text-champagne mt-2">Admin Access</p>
        <form onSubmit={submit} data-testid="login-form" className="bg-taupe rounded-2xl p-8 mt-8 space-y-5">
          <div>
            <label className="block text-sm font-medium text-espresso mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email" />
          </div>
          <div>
            <label className="block text-sm font-medium text-espresso mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password" />
          </div>
          {error && <p className="text-red-700 text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full inline-flex items-center justify-center gap-2 bg-espresso text-ivory rounded-full px-6 py-3 font-medium hover:bg-forest transition-colors disabled:opacity-60">
            {loading && <Loader2 className="animate-spin" size={18} />} Sign In
          </button>
          <div className="text-center">
            <Link to="/forgot-password" className="text-sm text-espresso/60 hover:text-espresso transition-colors" data-testid="login-forgot">Forgot password?</Link>
          </div>
        </form>
        <Link to="/" className="block text-center text-sm text-espresso/50 hover:text-espresso mt-6 transition-colors">← Back to site</Link>
      </div>
    </div>
  );
}
